import config from '../config'
import http from '../http'

export default{

    addBuyer:async function(payload) {
        const res = await http({
                url: config.ADD_BUYER,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },

    getBuyer:async function(payload) {
        const res = await http({
                url: config.GET_BUYER,
                method: 'post',
                data:{
                    ...payload
                }
            })
        return res.data
    },


}